import { Dialog } from "@mui/material"
import Button from "@mui/material/Button"
import type * as React from "react"
import { ExpertInsightsEmailExamples } from "./ExpertInsights/ExpertInsightsEmailExample/ExpertInsightsEmailExample"

interface EmailExampleDialogProps {
  dialogIsOpen: boolean
  setDialogIsOpen: (newState: boolean) => void
}

export const EmailExampleDialog: React.FC<EmailExampleDialogProps> = ({
  dialogIsOpen,
  setDialogIsOpen,
}) => {
  return (
    <Dialog
      onClose={() => setDialogIsOpen(false)}
      open={dialogIsOpen}
      slotProps={{
        paper: {
          style: {
            maxHeight: "100%",
            maxWidth: "500px",
            height: "fit-content",
            overflow: "auto",
            width: "100%",
            minWidth: "100px",
          },
        },
      }}
    >
      <ExpertInsightsEmailExamples />
      <CloseButton setDialogIsOpen={setDialogIsOpen} />
    </Dialog>
  )
}

const CloseButton: React.FC<{
  setDialogIsOpen: (newState: boolean) => void
}> = ({ setDialogIsOpen }) => {
  return (
    <Button
      variant="outlined"
      onClick={() => setDialogIsOpen(false)}
      sx={{
        padding: "7px 20px",
        width: "fit-content",
        marginTop: "20px",
        alignSelf: "end",
      }}
    >
      Close
    </Button>
  )
}
